__turbopack_context__.v({
  "hero-section-company-admin": "NdNiza_hero-section-company-admin",
  "hero-section-company-admin__action": "NdNiza_hero-section-company-admin__action",
  "hero-section-company-admin__description": "NdNiza_hero-section-company-admin__description",
});
